import { RefObject, useEffect } from "react";
import styles from "../styles/variables/_sizes.scss";

function calculateTopOffset(): number {
  const offsetSpace = 20;
  return parseInt(styles.headerHeight, 10) + parseInt(styles.accordionHeaderHeight, 10) + offsetSpace;
}

export function useScrollTo(reference: string | RefObject<HTMLElement>, onlyScrollIfFragmentPresentInUrl = false) {
  useEffect(() => {
    const referenceId = typeof reference === "string" ? reference : reference?.current?.id ?? "";
    const currentUrlFragment = window.location.hash.substring(1);

    if (onlyScrollIfFragmentPresentInUrl && currentUrlFragment?.toLowerCase() !== referenceId.toLowerCase()) return;

    const element = typeof reference === "string" ? document.getElementById(reference) : reference?.current;
    if (!element) return;

    window.scrollTo({
      top: element.getBoundingClientRect().top + window.scrollY - calculateTopOffset(),
      left: 0,
      behavior: "smooth",
    });
  }, []);
}
